import { directSupabase } from '../../../lib/supabaseClient';

export interface Material {
  id: string;
  organisation_id: string | null;
  sku?: string | null;
  name: string;
  supplier_name?: string | null;
  default_unit?: string | null;
  default_cost: number;
  stock_qty?: number | null;
  vat_inclusive?: boolean;
}

export interface Equipment {
  id: string;
  organisation_id: string | null;
  sku?: string | null;
  name: string;
  supplier_name?: string | null;
  default_unit?: string | null;
  default_cost: number;
  vat_inclusive?: boolean;
}

export interface LabourRate {
  id: string;
  organisation_id: string | null;
  name: string;
  rate_type: 'hour' | 'day';
  rate: number;
}

export const lookupsService = {
  // Materials
  async listMaterials(search?: string): Promise<Material[]> {
    let q = directSupabase.from('materials').select('*').order('name', { ascending: true });
    if (search) q = q.ilike('name', `%${search}%`);
    const { data, error } = await q;
    if (error) throw new Error(error.message);
    return (data || []) as unknown as Material[];
  },
  async upsertMaterial(payload: Partial<Material>): Promise<Material> {
    const { data, error } = await directSupabase.from('materials').upsert(payload).select('*').single();
    if (error) throw new Error(error.message);
    return data as unknown as Material;
  },
  async deleteMaterial(id: string): Promise<void> {
    const { error } = await directSupabase.from('materials').delete().eq('id', id);
    if (error) throw new Error(error.message);
  },

  // Equipment
  async listEquipment(search?: string): Promise<Equipment[]> {
    let q = directSupabase.from('equipment').select('*').order('name', { ascending: true });
    if (search) q = q.ilike('name', `%${search}%`);
    const { data, error } = await q;
    if (error) throw new Error(error.message);
    return (data || []) as unknown as Equipment[];
  },
  async upsertEquipment(payload: Partial<Equipment>): Promise<Equipment> {
    const { data, error } = await directSupabase.from('equipment').upsert(payload).select('*').single();
    if (error) throw new Error(error.message);
    return data as unknown as Equipment;
  },
  async deleteEquipment(id: string): Promise<void> {
    const { error } = await directSupabase.from('equipment').delete().eq('id', id);
    if (error) throw new Error(error.message);
  },

  // Labour rates
  async listLabourRates(search?: string): Promise<LabourRate[]> {
    let q = directSupabase.from('labour_rates').select('*').order('name', { ascending: true });
    if (search) q = q.ilike('name', `%${search}%`);
    const { data, error } = await q;
    if (error) throw new Error(error.message);
    return (data || []) as unknown as LabourRate[];
  },
  async upsertLabourRate(payload: Partial<LabourRate>): Promise<LabourRate> {
    const { data, error } = await directSupabase.from('labour_rates').upsert(payload).select('*').single();
    if (error) throw new Error(error.message);
    return data as unknown as LabourRate;
  },
  async deleteLabourRate(id: string): Promise<void> {
    const { error } = await directSupabase.from('labour_rates').delete().eq('id', id);
    if (error) throw new Error(error.message);
  },
};


